import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";

/**
 * SafeDatePicker
 * - Only commits VALID Date objects to parent state
 * - Ignores partial / invalid typed input
 * - Shows validation feedback
 */
const isValidDate = (value) =>
  value instanceof Date && !isNaN(value.getTime());

const SafeDatePicker = ({
  value,
  onChange,
  label,
  minDate,
  maxDate,
  format = "yyyy-MM-dd",
  size = "small",
  required = false,
  disabled = false,
}) => {
  const [error, setError] = useState(null);

  return (
    <DatePicker
      label={label}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      format={format}
      onError={(reason) => {
        setError(reason);
      }}
      onChange={(newValue) => {
        // ✅ only propagate valid dates
        if (!error && isValidDate(newValue)) {
          onChange(newValue);
        }
      }}
      slotProps={{
        textField: {
          size,
          required,
          error: Boolean(error),
          helperText: error ? "Invalid date" : "",
        },
      }}
    />
  );
};

export default SafeDatePicker;
